import * as React from 'react';
import Icon from 'components/Icon';

export interface LoadingScreenProps {
  title: string;
  message: string;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({ title, message }) => {
  return (
    <div className="ex3d-brand-page-background flex size-full flex-col items-center justify-center">
      <Icon className="ex3d-icon--car size-8 animate-bounce" />
      <h1 className="text-xl font-bold">{title}</h1>
      <p>{message}</p>
    </div>
  );
};

LoadingScreen.displayName = 'LoadingScreen';
